@if ({ underMaintenance: underMaintenance$ | async }; as source) {
	@if (source.underMaintenance === true) {
		<app-under-maintenance></app-under-maintenance>
	} @else if (source.underMaintenance === false) {
		<div class="app-layout bg">
			<app-header></app-header>
			<p-toast
				[breakpoints]="{
					'920px': { width: '100%', right: '0', top: '0', left: '0' },
				}"
			/>
			<main class="app-main" style="box-sizing: border-box">
				<router-outlet></router-outlet>
			</main>
			<footer *ngIf="environment !== TargetEnvironment.Hero" class="app-footer">
				<a
					href="https://teams.microsoft.com/l/team/19%3Af0563924f10948e29b24c3580bfa34a6%40thread.tacv2/conversations?groupId=34884b53-40a8-4388-b61a-a801abce4000&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
					target="_blank"
					rel="noopener noreferrer"
				>
					Support
				</a>
				<span aria-hidden="true" class="separator">•</span>
				<a href="https://confluence.collaborationlayer-traton.com/pages/viewpage.action?spaceKey=TW&title=DDB+and+Fenix+Toolchain+Help+pages" target="_blank" rel="noopener noreferrer">Wiki</a>
				<app-privacy-notice></app-privacy-notice>
			</footer>
		</div>
	}
}
